import { RootState } from "../../store";
import { TaskManagementState } from "../utils/types/types";

export const taskManagementSliceSelector = (
  state: RootState,
): TaskManagementState => {
  return state.taskManagement;
};
